// extracted by mini-css-extract-plugin
export default {"wrapper":"Shields_wrapper__cPQvd"};